import { Controller } from "@hotwired/stimulus"

// Uniwersalny drag&drop dla widoków kanban (projekty, zadania, ...).
// Karty przenoszone miedzy kolumnami wysylaja POST do `change_bulk_option`
// z type=status oraz value=<status_id z kolumny docelowej>.
//
// Konfiguracja (data-attrs):
//   root        — data-controller="kanban-drag"
//                 data-kanban-drag-url-template-value="/organize/projects/__ID__/change_bulk_option"
//   kolumna     — data-status-id="<id|empty>"
//                 data-action="dragover->kanban-drag#over dragleave->kanban-drag#leave drop->kanban-drag#drop"
//                 data-kanban-drag-target="dropzone" (na elemencie, do ktorego trafiaja karty)
//   karta       — draggable="true"
//                 data-id="<id|sid>"
//                 data-kanban-drag-target="card"
//                 data-action="dragstart->kanban-drag#start dragend->kanban-drag#end"
export default class extends Controller {
  static targets = ["card", "dropzone"]
  static values = { urlTemplate: String }

  start(event) {
    const id = event.currentTarget.dataset.id
    event.dataTransfer.setData("text/plain", id)
    event.dataTransfer.effectAllowed = "move"
    event.currentTarget.classList.add("opacity-50")
  }

  end(event) {
    event.currentTarget.classList.remove("opacity-50")
  }

  over(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"
    event.currentTarget.classList.add("bg-blue-50")
  }

  leave(event) {
    event.currentTarget.classList.remove("bg-blue-50")
  }

  drop(event) {
    event.preventDefault()
    const dropzone = event.currentTarget
    dropzone.classList.remove("bg-blue-50")

    const id = event.dataTransfer.getData("text/plain")
    if (!id) return

    const card = this.cardTargets.find((c) => c.dataset.id === id)
    if (!card) return

    // status_id moze byc pusty (kolumna "bez statusu")
    const statusHolder = dropzone.closest("[data-status-id]")
    const statusId = statusHolder ? statusHolder.dataset.statusId : ""

    // optimistic move
    if (card.parentElement !== dropzone) {
      dropzone.appendChild(card)
    }

    this.sendStatusChange(id, statusId)
  }

  sendStatusChange(id, statusId) {
    const url = this.urlTemplateValue.replace("__ID__", encodeURIComponent(id))
    const body = new FormData()
    body.append("type", "status")
    body.append("value", statusId || "")

    const meta = document.querySelector("meta[name=\"csrf-token\"]")
    fetch(url, {
      method: "POST",
      headers: {
        "X-CSRF-Token": meta ? meta.content : "",
        Accept: "application/json",
      },
      body,
    }).then((response) => {
      if (!response.ok) {
        console.error("kanban-drag: status update failed", response.status)
      }
    }).catch((error) => {
      console.error("kanban-drag: status update error", error)
    })
  }
}
